import angular from 'angular';
import galleryMod from './app';
import galleryCtrl from './gallery/galleryController';
import trackCtrl from './shared/trackController';
import galleryAnalytics from './analytics/analyticsService';
import trackable from './shared/trackableDirective';
import trackIt from './shared/trackItDirective';




// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/gallery.js